const iframeDashboardSettings = {
  fsnrl: {
    url: "https://apps.nphl.go.ke/metabase/public/dashboard/a413eaf7-926f-4fb1-9d97-330c4cd18940",
    workloadSrc: "https://apps.nphl.go.ke/metabase/public/question/7c1bf74d-0912-42a2-abe9-baf98bd6800c",
    dashboardLocation: "/public/fsnrl",
    height: "24rem",
    width: "100%",
    className: "h-[24rem]",
  },
  gmsl: {
    url: "https://apps.nphl.go.ke/metabase/public/dashboard/a9d491d7-acfe-4f47-a8e8-701a4344c090",
    workloadSrc: "https://apps.nphl.go.ke/metabase/public/question/8bf1ffee-e272-4547-a8e6-f5013c445239",
    dashboardLocation: "/public/gmsl",
    height: "24rem",
    width: "100%",
    className: "h-[24rem]",
  },
  nic: {
    url: "https://apps.nphl.go.ke/metabase/public/dashboard/b17853bd-7953-4cf3-8c0c-b01124be490a",
    workloadSrc: "https://apps.nphl.go.ke/metabase/public/question/66bef36c-1bde-4062-9d68-93a57bf93d3b",
    dashboardLocation: "/public/nic",
    height: "24rem",
    width: "100%",
    className: "h-[24rem]",
  },
  nmrl: {
    url: "https://apps.nphl.go.ke/metabase/public/dashboard/9cc089bb-d752-4459-aa80-32f2933e9f78",
    workloadSrc: "https://apps.nphl.go.ke/metabase/public/question/c2993e5b-8efa-481a-a570-c2a0885dbb5f",
    dashboardLocation: "/public/nmrl",
    height: "24rem",
    width: "100%",
    className: "h-[24rem]",
  },
  nobrl: {
    url: "https://apps.nphl.go.ke/metabase/public/dashboard/af9b0fa7-9e01-4350-be0d-4d484b879b9a",
    workloadSrc: "https://apps.nphl.go.ke/metabase/public/question/c7c43603-9942-43e3-8de4-da49b7db9862",
    dashboardLocation: "/public/nobrl",
    height: "24rem",
    width: "100%",
    className: "h-[24rem]",
  },
  nhrl: {
    url: "https://apps.nphl.go.ke/metabase/public/dashboard/1d9fc926-a462-4084-a245-14b8cdad7ab5",
    workloadSrc: "https://apps.nphl.go.ke/metabase/public/question/2244b1a4-7021-463e-b84a-55afae54364d",
    dashboardLocation: "/public/nhrl",
    height: "24rem",
    width: "100%",
    className: "h-[24rem]",
  },
  nvrl: {
    url: "https://apps.nphl.go.ke/metabase/public/dashboard/27895261-b2f4-4c93-992f-d8d0ba39c048",
    workloadSrc: "https://apps.nphl.go.ke/metabase/public/question/4e75365d-f071-4e59-b008-6276eabeb87a",
    dashboardLocation: "/public/nvrl",
    height: "24rem",
    width: "100%",
    className: "h-[24rem]",
  },
  coe: {
    url: "https://apps.nphl.go.ke/metabase/public/dashboard/5480edc3-dc07-4162-8805-1de2ec543c5d",
    workloadSrc: "https://apps.nphl.go.ke/metabase/public/question/80bffaf1-234f-49d1-a306-54afc767821e",
    dashboardLocation: "/public/coe",
    height: "24rem",
    width: "100%",
    className: "h-[24rem]",
  },
  monitoring: {
    url: "http://172.0.16.151:3210",
    workloadSrc: "",
    dashboardLocation: "/public/monitoring",
    height: "24rem",
    width: "100%",
    className: "h-[24rem]",
  },
};

export default iframeDashboardSettings;
